var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-button',{class:[
    ("md-raised md-" + _vm.color),
    _vm.block ? 'btn-block' : null,
    ("btn-" + _vm.size),
    _vm.classes ],attrs:{"type":_vm.type,"disabled":_vm.loading}},[(!_vm.loading)?_vm._t("default"):_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-fw"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }